export const EMAIL_LOCAL_STORAGE_KEY = 'emailForSignIn';
